export default __webpack_public_path__ + "static/media/empty-result.e0649a99.svg";